export default __webpack_public_path__ + "static/media/loading.bbad3c05.gif";